module.exports = __webpack_public_path__ + "img/las.cc17d43d.png";